<!-- Young <a-icon type="down" />-->
<template>
  <div class="public-top-bar">
    <div class="tool-wrap">
      <div class="tool-wrap-left">
        <a-input-search
          :placeholder="placeholder"
          style="width: 396px"
          v-model.trim="basicVal"
          @change="changeValue"
          @search="onTableSearchFun"
        />
        <slot name="topBarLeft"></slot>
        <div
          v-for="(i, index) in topBarBtns"
          :key="index"
          style="display: inline-block;"
        >
          <!-- 下拉按钮{dropDown,dropItem:{key,name}} -->
          <a-dropdown v-if="i.dropDown" style="margin-left:24px">
            <a-menu slot="overlay" @click="clickBtn(i, $event)">
              <a-menu-item v-for="item of i.dropItem" :key="item.key">{{
                item.name
              }}</a-menu-item>
            </a-menu>
            <a-button :type="i.type">
              {{ i.name }}
              <a-icon type="down" />
            </a-button>
          </a-dropdown>
          <a-button
            v-else
            @click="clickBtn(i)"
            :type="i.type"
            class="tool-btn"
            :class="{ noFirst: i.type !== 'primary' }"
            >{{ i.name }}</a-button
          >
        </div>
        <div v-if="showHighSearch" style="display: inline-block;">
          <a-button
            class="tool-btn tool-btn-2"
            @click="ifShowHigh = !ifShowHigh"
            >{{ ifShowHigh ? "收起" : "高级搜索" }}</a-button
          >
        </div>
      </div>
    </div>
    <div class="high-search-wrap" v-if="ifShowHigh">
      <div class="high-bar" :class="{ ifShow: ifShowHigh }">
        <slot name="highSearchGroup"></slot>
        <a-button
          type="primary"
          class="tool-btn"
          style="margin-left: 0;"
          @click="onTableSearchFun"
          >查询</a-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PublicTopBar",
  props: {
    placeholder: { required: true, default: "" },
    topBarBtns: { required: true, type: Array },
    showHighSearch: { required: false, type: Boolean, default: false },
    onTableSearchFun: { required: true, type: Function },
    ifShowHighFlag: { required: false, type: Boolean, default: false },
    resetSearch: { required: false, type: Boolean, default: false }
  },
  data() {
    return {
      ifShowHigh: false,
      basicVal: ""
    };
  },
  watch: {
    ifShowHighFlag: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.ifShowHigh = true;
        }
      }
    },
    resetSearch: {
      immediate: true,
      handler: function(val) {
        if (val) {
          this.basicVal = "";
          this.$emit("unresetSearchFun");
        }
      }
    }
  },
  methods: {
    changeValue(e) {
      this.$emit("changeBasicSearchFun", e.target.value);
    },

    clickBtn(item, val) {
      if (item.fun) {
        if (val) {
          item.fun(val.key);
        } else {
          item.fun();
        }
      }
      return undefined;
    }
  }
};
</script>
<style lang="less">
.high-search-wrap {
  .ant-calendar-range-picker-input {
    text-align: left !important;
  }
}
</style>
<style lang="less" scoped>
// @import url(); 引入公共css类
.public-top-bar {
  // min-height: 136px;
  padding: 24px;
  background: #ffffff;


  .tool-btn {
    min-width: 88px;
    height: 32px;
    margin-left: 24px;
    border-radius: 3px;
    border: 0px;
  }
  .tool-btn-2 {
    background: #ecedff;
    color: #5862cb;
  }
  .icon-down {
    color: #5862cb;
    margin-left: 10px;
    font-weight: bold;
  }
  .noFirst {
    background: #ecedff;
    color: #5862cb;
  }
  .tool-wrap {
    display: flex;
  }
  .high-search-wrap {
    margin-top: 32px;
  }
}
</style>
